import { IUserPersona } from './user-persona.model';
import UserAvatarView from './user-persona.view';

const UserPresenceController = (props: IUserPersona): JSX.Element => {
  return <UserAvatarView {...props} />;
};

export default UserPresenceController;
